var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59186 3.8129L10.1026 2.90646C10.5676 2.62745 10.8001 2.48795 10.9914 2.50579C11.1582 2.52134 11.3104 2.6075 11.4095 2.74254C11.5233 2.89741 11.5233 3.16854 11.5233 3.71082V6.26009C11.5233 6.80234 11.5233 7.07349 11.4095 7.22839C11.3104 7.36341 11.1582 7.44959 10.9914 7.46513C10.8001 7.48295 10.5676 7.34348 10.1026 7.06447L8.59186 6.15802M2.84631 8.50314H6.71576C7.37246 8.50314 7.70083 8.50314 7.95164 8.37533C8.17226 8.26294 8.35166 8.08354 8.46405 7.86292C8.59186 7.61211 8.59186 7.28373 8.59186 6.62704V3.34387C8.59186 2.68718 8.59186 2.35883 8.46405 2.108C8.35166 1.88737 8.17226 1.70799 7.95164 1.59558C7.70083 1.46777 7.37246 1.46777 6.71576 1.46777H2.84631C2.18962 1.46777 1.86127 1.46777 1.61044 1.59558C1.38981 1.70799 1.21043 1.88737 1.09802 2.108C0.970215 2.35883 0.970215 2.68717 0.970215 3.34387V6.62704C0.970215 7.28373 0.970215 7.61211 1.09802 7.86292C1.21043 8.08354 1.38981 8.26294 1.61044 8.37533C1.86127 8.50314 2.18961 8.50314 2.84631 8.50314Z",
    stroke: "white",
    strokeWidth: 0.968804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCb);
export default __webpack_public_path__ + "static/media/video-cb.ca2c6a4d71b8ae549d6dea4e048b1a47.svg";
export { ForwardRef as ReactComponent };